import { useTenantConfig } from './useTenantConfig';
import { useTenantAppearance as useTenantAppearanceCommon } from '@enterprise/common';
export { Logo } from '@enterprise/common';

export const useTenantAppearance = () => {
  const tenantConfig = useTenantConfig();

  return useTenantAppearanceCommon(!!tenantConfig?.features, {
    logoUid: tenantConfig?.logo?.uid,
    bannerText: tenantConfig?.features?.appearance?.config?.['banner-text'] ?? ''
  });
};
